module.exports = __webpack_public_path__ + "img/logo-patch_black.829fa2dd.png";